import React from 'react';

import '../../styles/list-results-bar.css';

export interface ListResultsBarProps {
  countLabel: React.ReactNode;
  /** Optional right-side controls (e.g. Activity sort). */
  trailing?: React.ReactNode;
  className?: string;
}

const ListResultsBar: React.FC<ListResultsBarProps> = ({ countLabel, trailing, className }) => (
  <div className={`list-results-bar${className ? ` ${className}` : ''}`.trim()}>
    <span className="list-results-bar__count">{countLabel}</span>
    {trailing}
  </div>
);

export default ListResultsBar;
